export default "-- RTABench Q2\nSELECT\n    max(counter)\nFROM\n    order_events\nWHERE\n    event_created >= '2024-04-20' and event_created < '2024-05-20';\n";